// 📁 api/crm/customers/info.js
import axiosInstance from "../../axiosInstance";
const BASE_URL = "/crm/customer_tags";

// 🔍 Lấy tất cả tags
export const getAllCustomerTags = async () => {
  try {
    const res = await axiosInstance.get(`${BASE_URL}/list`, {
      skipGlobalErrorToast: true,
    });
    return {
      items: res.data.items || [],
      total: res.data.total || 0
    };
  } catch (error) {
    console.error("❌ Lỗi khi lấy danh sách tag khách hàng:", error);
    return { items: [], total: 0 };
  }
};



// ➕ Tạo tag mới
export const createCustomerTag = async (data) => {
  try {
    const res = await axiosInstance.post(`${BASE_URL}/create`, data);
    return res.data;
  } catch (error) {
    console.error("❌ Lỗi khi tạo tag khách hàng:", error);
    throw error;
  }
};

// ✏️ Cập nhật tag
export const updateCustomerTag = async (id, data) => {
  try {
    const res = await axiosInstance.put(`${BASE_URL}/update/${id}`, data);
    return res.data;
  } catch (error) {
    console.error("❌ Lỗi khi cập nhật tag khách hàng:", error);
    throw error;
  }
};

// ❌ Xoá tag
export const deleteCustomerTag = async (id) => {
  try {
    const res = await axiosInstance.delete(`${BASE_URL}/delete/${id}`);
    return res.data;
  } catch (error) {
    console.error("❌ Lỗi khi xoá tag khách hàng:", error);
    throw error;
  }
};

// 📌 Lấy thống kê sử dụng tag của khách hàng
export const getCustomerTagUsage = async () => {
  try {
    const res = await axiosInstance.get(`${BASE_URL}/usage`);
    return res.data.items;
  } catch (error) {
    console.error("❌ Lỗi khi lấy thống kê sử dụng tag khách hàng:", error);
    throw error;
  }
};

// 📌 Gộp tag khách hàng
export const mergeCustomerTags = async (payload) => {
  try {
    const res = await axiosInstance.post(`${BASE_URL}/merge`, payload);
    return res.data;
  } catch (error) {
    console.error("❌ Lỗi khi gộp tag khách hàng:", error);
    throw error;
  }
};
